// extracted by mini-css-extract-plugin
export default {"mainContent":"Clients_mainContent__tvL-K","clientLogo":"Clients_clientLogo__0cZSR"};